import { useState } from "react";

const faqs = [
  { q: "Is WalkBattle free to use?", a: "Yes, completely free. No subscriptions, no paywalls. Download, create an account, and start walking. Coins are earned through activity, not purchased." },
  { q: "How does territory claiming work?", a: "Walk a path (road/route) for 5 consecutive days to fully claim it. Partial walks count toward progress. If a rival walks the same path more than you in any 5-day window, they can reclaim it." },
  { q: "How does the leaderboard work?", a: "We have 3 leaderboards — Total Distance (km), Territories Owned, and Active Streak (days). Rankings update in real-time and you compete in 5km, 100km, and city-wide radius brackets." },
  { q: "Can I challenge specific friends?", a: "Yes! Go to any user's profile, tap '⚔️ Challenge', choose your battle duration (1 day, 3 days, or 7 days), and they'll get a push notification. Most steps in the duration wins." },
  { q: "Does the app work indoors on a treadmill?", a: "Step tracking uses both GPS and accelerometer. Indoor walking on a treadmill counts toward your step goals but GPS paths won't be recorded for territory claiming." },
  { q: "What happens to my territories if I stop walking?", a: "Territories stay yours until someone out-walks you on that path for 5 days. If you go 7 days without walking any claimed path, those territories become 'vulnerable' (shown in yellow on the map)." },
  { q: "How are coins and rewards calculated?", a: "Base: 1 coin per 100 steps. Streak bonus: 2x after 7 days, 3x after 30 days. Territory ownership: +50 coins/day per territory. Battle win: +500 coins. Milestone badges: 100-500 coins each." },
  { q: "Is my location data safe?", a: "Your location is only stored as aggregated path data — we don't store your real-time location history. Walk data is encrypted and never sold to third parties. See our Privacy Policy for full details." },
];

function FAQItem({ q, a, open, onClick }) {
  return (
    <div
      style={{
        background: "var(--surface)",
        border: `1px solid ${open ? "rgba(0,245,196,0.3)" : "var(--border)"}`,
        borderRadius: 10,
        overflow: "hidden",
        transition: "all 0.3s ease",
        boxShadow: open ? "0 8px 24px rgba(0,0,0,0.3)" : "none",
      }}
    >
      <button
        onClick={onClick}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "18px 20px",
          background: "none",
          border: "none",
          cursor: "pointer",
          textAlign: "left",
          gap: 14,
        }}
      >
        <span
          style={{
            fontFamily: "'Rajdhani', sans-serif",
            fontSize: "clamp(15px, 2.5vw, 17px)",
            fontWeight: 700,
            color: open ? "var(--neon)" : "var(--text)",
            transition: "color 0.3s",
            lineHeight: 1.4,
          }}
        >
          {q}
        </span>
        <span
          style={{
            color: open ? "var(--neon)" : "var(--muted)",
            fontSize: 20,
            flexShrink: 0,
            transform: open ? "rotate(45deg)" : "none",
            transition: "transform 0.3s, color 0.3s",
            fontWeight: 300,
          }}
        >
          +
        </span>
      </button>
      {open && (
        <div
          style={{
            padding: "0 20px 18px",
            color: "var(--muted)",
            fontSize: 14,
            lineHeight: 1.8,
            animation: "fadeInUp 0.3s ease both",
          }}
        >
          {a}
        </div>
      )}
    </div>
  );
}

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <div style={{ background: "var(--bg)", minHeight: "100vh", paddingTop: 80, overflowX: "hidden" }}>
      <style>{`
        .wb-faq-section {
          padding: 80px 48px;
          max-width: 800px;
          margin: 0 auto;
        }

        /* Tablet (768px - 1024px) */
        @media (max-width: 1024px) {
          .wb-faq-section {
            padding: 60px 28px;
          }
        }

        /* Mobile (< 640px) */
        @media (max-width: 640px) {
          .wb-faq-section {
            padding: 48px 16px;
          }
        }
      `}</style>

      <section className="wb-faq-section">
        <div style={{ textAlign: "center", marginBottom: 44 }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              background: "rgba(123,97,255,0.07)",
              border: "1px solid rgba(123,97,255,0.2)",
              padding: "6px 16px",
              borderRadius: 100,
              marginBottom: 18,
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: 11,
              color: "var(--neon3)",
              letterSpacing: 2,
              textTransform: "uppercase",
            }}
          >
            ❓ FAQ
          </div>
          <h1
            style={{
              fontFamily: "'Orbitron', monospace",
              fontSize: "clamp(26px, 5vw, 48px)",
              fontWeight: 900,
              color: "var(--text)",
              marginBottom: 14,
              lineHeight: 1.1,
            }}
          >
            Got <span style={{ color: "var(--neon3)" }}>Questions?</span>
          </h1>
          <p style={{ color: "var(--muted)", fontSize: "clamp(14px, 2vw, 16px)", lineHeight: 1.7 }}>
            Everything you need to know before joining the battle.
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {faqs.map((f, i) => (
            <FAQItem key={i} q={f.q} a={f.a} open={open === i} onClick={() => setOpen(open === i ? -1 : i)} />
          ))}
        </div>
      </section>
    </div>
  );
}

